var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-wrapper", class: [_vm.listShow] }, [
    _c(
      "div",
      { staticClass: "main-container" },
      [
        !_vm.isAiKnowledgeRoute ? _c("navbar") : _vm._e(),
        _vm._v(" "),
        _c("app-main", { staticClass: "app-main" })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }